import React from "react";
import { BsCheckCircle } from "react-icons/bs";
import { MdOutlineEmail } from "react-icons/md";

const TicketPaymentConfirmation = () => {
  const containerStyle = {
    maxWidth: "600px",
    margin: "40px auto",
    padding: "20px",
    fontFamily: "sans-serif",
    backgroundColor: "#fff",
    borderRadius: "0.5rem",
  };

  const checkIconContainerStyle = {
    width: "64px",
    height: "64px",
    backgroundColor: "#ecfdf5",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 24px"
  };

  const checkIconStyle = {
    color: "#10b981",
    fontSize: "32px"
  };

  const headerStyle = {
    textAlign: "center",
    marginBottom: "40px"
  };

  const titleStyle = {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "16px",
    color: "#111827"
  };

  const subtitleStyle = {
    color: "#6b7280",
    fontSize: "16px",
    lineHeight: "1.5",
    maxWidth: "400px",
    margin: "0 auto"
  };

  const cardStyle = {
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "32px",
    backgroundColor: "#f9fafb"
  };

  const cardTitleStyle = {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "16px",
    color: "#111827",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  };

  const listStyle = {
    listStyle: "none",
    padding: 0,
    margin: 0
  };

  const listItemStyle = {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "16px",
    color: "#4b5563",
    fontSize: "14px",
    lineHeight: "1.5"
  };

  const bulletStyle = {
    color: "rgb(247, 152, 60)",
    fontSize: "20px",
    lineHeight: "1"
  };

  const buttonStyle = {
    width: "100%",
    padding: "16px",
    background: "linear-gradient(to right, rgb(247, 152, 60), rgb(255, 124, 110))",
    color: "white",
    border: "none",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    marginBottom: "16px",
    transition: "background-color 0.2s"
  };

  const buttonHoverStyle = {
    backgroundColor: "#4f46e5"
  };

  const linkStyle = {
    color: "rgb(247, 152, 60)",
    textDecoration: "none",
    display: "block",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "500"
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <div style={checkIconContainerStyle}>
          <BsCheckCircle style={checkIconStyle} />
        </div>
        <h1 style={titleStyle}>Purchase Confirmed!</h1>
        <p style={subtitleStyle}>
          Thank you for your purchase. <br /> Your tickets have been sent to your email address.
        </p>
      </div>

      <div style={cardStyle}>
        <h2 style={cardTitleStyle}>
          <MdOutlineEmail size={24} />
          What's Next?
        </h2>
        <ul style={listStyle}>
          <li style={listItemStyle}>
            <span style={bulletStyle}>•</span>
            Check your email inbox for your ticket confirmation
          </li>
          <li style={listItemStyle}>
            <span style={bulletStyle}>•</span>
            Your tickets will be attached to the email as a PDF
          </li>
          <li style={listItemStyle}>
            <span style={bulletStyle}>•</span>
            Present your ticket at the event entrance
          </li>
          <li style={listItemStyle}>
            <span style={bulletStyle}>•</span>
            If you don't receive the email within 5 minutes, please check your spam folder
          </li>
        </ul>
      </div>

      <button 
        style={buttonStyle}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = buttonHoverStyle.backgroundColor}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor}
        onClick={() => window.location.href = 'mailto:'}
      >
        Open Mailbox
      </button>

      <a href="mailto:support@kago.digital" style={linkStyle}>
        Need help? Contact our support team
      </a>
    </div>
  );
};

export default TicketPaymentConfirmation;
